import { render, staticRenderFns } from "./CVTypeEducation.vue?vue&type=template&id=af6ae13a"
import script from "./CVTypeEducation.vue?vue&type=script&lang=js"
export * from "./CVTypeEducation.vue?vue&type=script&lang=js"
import style0 from "./CVTypeEducation.vue?vue&type=style&index=0&id=af6ae13a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports